import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceCategories = ({ onBookService }) => {
  const services = [
    {
      icon: 'Zap',
      title: 'Réparations d\'urgence',
      description: 'Fuites, canalisations bouchées, pannes de chauffe-eau. Intervention rapide 24/7.',
      price: 'À partir de 89€',
      features: ['Intervention sous 2h', 'Disponible 24/7', 'Devis sur place'],
      color: 'error'
    },
    {
      icon: 'Wrench',
      title: 'Installations',
      description: 'Pose de sanitaires, robinetterie, chauffe-eau, systèmes de filtration.',
      price: 'À partir de 150€',
      features: ['Matériel certifié', 'Garantie 6 mois', 'Devis gratuit'],
      color: 'primary'
    },
    {
      icon: 'Settings',
      title: 'Maintenance préventive',
      description: 'Entretien régulier, détartrage, contrôle des installations, prévention des pannes.',
      price: 'À partir de 75€',
      features: ['Forfaits annuels', 'Rappels automatiques', 'Économies garanties'],
      color: 'success'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Nos services de plomberie
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Des solutions adaptées à tous vos besoins, avec des tarifs transparents et des techniciens qualifiés.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {services?.map((service, index) => (
            <div 
              key={index}
              className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-shadow"
            >
              <div className={`w-14 h-14 rounded-lg bg-${service?.color}/10 flex items-center justify-center mb-4`}>
                <Icon name={service?.icon} size={28} className={`text-${service?.color}`} />
              </div>
              
              <h3 className="text-xl font-semibold text-foreground mb-2">
                {service?.title}
              </h3>
              
              <p className="text-muted-foreground mb-4">
                {service?.description}
              </p>
              
              <div className="text-2xl font-bold text-primary mb-4">
                {service?.price}
              </div>
              
              <ul className="space-y-2 mb-6">
                {service?.features?.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-muted-foreground">
                    <Icon name="Check" size={16} className="text-success" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              
              <Button
                variant="outline"
                fullWidth
                iconName="ArrowRight"
                iconPosition="right"
                onClick={onBookService}
              >
                Réserver ce service
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCategories;